
import { urlPort } from '../../socket.js';
import { Point } from '../Point.js';
import { createNodeLine, RunNearPoint } from './Fun.js';

export let AllMallData = {}

export async function ReadFileAllMallData(mallid) {
    try {

        // if(window.navigator.onLine){
        // }
        if (localStorage.getItem("mallid" + mallid)) {
            var jsonMallData = JSON.parse(localStorage.getItem("mallid" + mallid))
            localStorage.setItem("floorCameraData",JSON.stringify(jsonMallData.data?.more?.viewState || {}));

            var res = fetch(urlPort + "/apidata/" + mallid+".json").then(d => d.json()).then(d => {
                // console.clear()
                
                localStorage.setItem("floorCameraData",JSON.stringify(d.data?.more?.viewState || {}));
                localStorage.setItem("mallid" + mallid, JSON.stringify(d))
            })
        } else {
            var res = await fetch(urlPort + "/apidata/" + mallid+".json")
            
            var jsonMallData = await res.json()
            localStorage.setItem("floorCameraData",JSON.stringify(jsonMallData.data?.more?.viewState || {}));
            
            localStorage.setItem("mallid" + mallid, JSON.stringify(jsonMallData))
        }
        // debugger
        AllMallData[mallid] = {}
        AllMallData[mallid].nodePoint = {}
        AllMallData[mallid].nodeLine = {}
        // let x = JSON.parse(jsonMallData)
        let x = jsonMallData.data
        // 
        AllMallData[mallid].width = x.width;
        AllMallData[mallid].height = x.height;
        let imageData = x.FloorImg;
        // for (let i = 0; i < x.FloorImg.length; i++) {
        //     const image = x.FloorImg[i];
        //     let img = { src: image.FloorUrl, width: x.width, height: x.height };
        //     imageData.push({
        //         ...image,
        //         FloorUrl: img,
        //     });
        // }

        AllMallData[mallid].FloorImg = imageData
        AllMallData[mallid].TotleFloor = imageData.length
        if (x.DefaultFloor) {
            AllMallData[mallid].DefaultFloor = x.DefaultFloor
        }
        AllMallData[mallid].w = x.w
        AllMallData[mallid].h = x.h
        AllMallData[mallid].DefaultDist = x.DefaultDist
        x.filterNodePoint.forEach((d, i) => {
            AllMallData[mallid].nodePoint[`${d.x},${d.y},${d.z}`] = { x: d.x, y: d.y, z: d.z, name: `grid[${d.x}][${d.y}][${d.z}]`, point: new Point(d.x, d.y, d.z) }
            if (d?.LocationName) AllMallData[mallid].nodePoint[`${d.x},${d.y},${d.z}`].point.LocationName = d.LocationName
            if (d?.Category) AllMallData[mallid].nodePoint[`${d.x},${d.y},${d.z}`].point.Category = d.Category
            if (d?.type) AllMallData[mallid].nodePoint[`${d.x},${d.y},${d.z}`].point.type = d.type
            if (d?.LeaseType) AllMallData[mallid].nodePoint[`${d.x},${d.y},${d.z}`].point.LeaseType = d.LeaseType
            if (d?.logo) AllMallData[mallid].nodePoint[`${d.x},${d.y},${d.z}`].point.logo = d.logo
            if (d?.elementTag) AllMallData[mallid].nodePoint[`${d.x},${d.y},${d.z}`].point.elementTag = d.elementTag
            if (d?.color) AllMallData[mallid].nodePoint[`${d.x},${d.y},${d.z}`].point.color = d.color
            if (d?.Description) AllMallData[mallid].nodePoint[`${d.x},${d.y},${d.z}`].point.Description = d.Description
            if (d?.shape) AllMallData[mallid].nodePoint[`${d.x},${d.y},${d.z}`].point.shape = d.shape
            if (d?.up) AllMallData[mallid].nodePoint[`${d.x},${d.y},${d.z}`].point.up = d.up
            if (d?.floorBash) AllMallData[mallid].nodePoint[`${d.x},${d.y},${d.z}`].point.floorBash = d.floorBash
            if (d?.down) AllMallData[mallid].nodePoint[`${d.x},${d.y},${d.z}`].point.down = d.down
            if (d?.extra) AllMallData[mallid].nodePoint[`${d.x},${d.y},${d.z}`].point.extra = d.extra
            if (d?.brand_Id) AllMallData[mallid].nodePoint[`${d.x},${d.y},${d.z}`].point.brand_Id = d.brand_Id
        })
        x.filterNodeLine.forEach(d => {
            AllMallData[mallid].nodeLine[`${d.a.x},${d.a.y},${d.a.z}To${d.b.x},${d.b.y},${d.b.z}`] = createNodeLine(AllMallData[mallid], d.a, d.b)
        })
        let { nodePoint, nodeLine } = RunNearPoint(AllMallData[mallid].nodePoint, AllMallData[mallid].nodeLine);
        AllMallData[mallid].nodePoint = nodePoint
        AllMallData[mallid].nodeLine = nodeLine
        // 
        // AllMallData[mallid]=
        // return "data load"
        return AllMallData[mallid]
    }
    catch {
        return "data not  load"
        
    }
}
